import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';
import { logStartGreyError } from 'owa-analytics-start/lib/logStartUsage';

// Do not log from then 10 entries for a given client
const maxLoggingCount = 10;
let loggingCount = 0;

/**
 * To help determine why we have MailboxInfo's without diagnostic data we need to check
 * the mailbox info when the request is made. This will help to track down the callers
 * that are not setting the diagnostic data for the MailboxInfo
 * @param mailboxInfo MailboxInfo to be checked for diagnostic data
 */
export function checkMailboxInfoForDiagnosticData(
    mailboxInfo?: MailboxInfo,
    callerStack?: string
): void {
    if (!!mailboxInfo && !mailboxInfo.diagnosticData && loggingCount < maxLoggingCount) {
        loggingCount++;
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartGreyError(
            'MailboxInfoDiagnosticDataMissing',
            undefined,
            new Error('MailboxInfoDiagnosticDataMissing'),
            { type: mailboxInfo.type, callerStack }
        );
    }
}
